import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _ERROR_MESSAGES;

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n\n          padding: 20px;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n\n          padding: 30px;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 0;\n  z-index: 1;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { position } from 'polished';
import { color } from '@scp/ui-shared/theme/variables';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { VisuallyHiddenElement } from '@scp/ui-shared/theme/resets';
import { Button } from '@scp/ui-shared/components/buttons';
import { Modal } from '@scp/ui-shared/components/modals';
import { validateAttachment, parseFileSize } from './utils';
import { UploadConfirmModal } from './UploadConfirmModal';
import { withHipaaConfirm } from './withHipaaConfirm';
import { DropArea } from './DropArea';
import { DEFAULT_ACCEPTED_FILES, HIPAA_UPLOAD_WARNING_TEXT, MAX_FILE_SIZE } from './constants';
import { UploadAction, ValidationErrors } from './enums';
var TEXT = {
  DEFAULT_BTN_TITLE: 'Upload a file',
  ERROR_DISMISS_BTN: 'OK'
};
var ERROR_MESSAGES = (_ERROR_MESSAGES = {}, _defineProperty(_ERROR_MESSAGES, ValidationErrors.SizeError, {
  title: 'Document error',
  description: "Unable to upload documents larger than ".concat(parseFileSize(MAX_FILE_SIZE), ".")
}), _defineProperty(_ERROR_MESSAGES, ValidationErrors.FormatError, {
  title: 'File format error',
  description: 'Unable to upload documents in the selected file format.'
}), _defineProperty(_ERROR_MESSAGES, ValidationErrors.QuantityError, {
  title: 'Upload error',
  description: 'Unable to send more than 10 attachments at a time.'
}), _defineProperty(_ERROR_MESSAGES, ValidationErrors.TotalQuantityError, {
  title: 'Upload error',
  description: 'Upload limit reached: maximum uploads count 50.'
}), _ERROR_MESSAGES);
var HoverDropAreaWithoutProps = withoutProps(DropArea, ['isInsideModal']);
var HoverDropArea = styled(HoverDropAreaWithoutProps)(_templateObject(), color.background, function (props) {
  return !props.isInsideModal ? css(_templateObject2(), position('absolute', '60px', 0, 0, 0)) : css(_templateObject3(), position('absolute', '60px', 0, '57px', 0));
});
export var FileUploadTrigger = withHipaaConfirm({
  confirmText: HIPAA_UPLOAD_WARNING_TEXT
})( // Comment to force prettier to fold line and meet line-max-length rule
function (_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? function (props) {
    return React.createElement(Button, Object.assign({}, props), TEXT.DEFAULT_BTN_TITLE);
  } : _a$children,
      _a$errorMessages = _a.errorMessages,
      errorMessages = _a$errorMessages === void 0 ? ERROR_MESSAGES : _a$errorMessages,
      isDropArea = _a.isDropArea,
      checkHipaa = _a.checkHipaa,
      onFileUpload = _a.onFileUpload,
      onFileSelect = _a.onFileSelect,
      _a$acceptedFiles = _a.acceptedFiles,
      acceptedFiles = _a$acceptedFiles === void 0 ? DEFAULT_ACCEPTED_FILES : _a$acceptedFiles,
      disabled = _a.disabled,
      fileUploadToTitle = _a.fileUploadToTitle,
      isInsideModal = _a.isInsideModal,
      _a$fileLimit = _a.fileLimit,
      fileLimit = _a$fileLimit === void 0 ? Infinity : _a$fileLimit,
      _a$fileCount = _a.fileCount,
      fileCount = _a$fileCount === void 0 ? 0 : _a$fileCount,
      uploadType = _a.uploadType,
      confirmLabel = _a.confirmLabel,
      btnProps = __rest(_a, ["children", "errorMessages", "isDropArea", "checkHipaa", "onFileUpload", "onFileSelect", "acceptedFiles", "disabled", "fileUploadToTitle", "isInsideModal", "fileLimit", "fileCount", "uploadType", "confirmLabel"]);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      uploadedFile = _useState2[0],
      setUploadedFile = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      uploadError = _useState4[0],
      setUploadError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFrameDragActive = _useState6[0],
      setIsFrameDragActive = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      files = _useState8[0],
      setFiles = _useState8[1];

  var _useState9 = useState(0),
      _useState10 = _slicedToArray(_useState9, 2),
      activeFileIndex = _useState10[0],
      setActiveFileIndex = _useState10[1];

  var fileInput = useRef(null);
  useEffect(function () {
    document.addEventListener('dragenter', handleDragEnter);
    document.addEventListener('dragend', handleDragEnd);
    document.addEventListener('mouseleave', handleDragEnd);
    return function () {
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('dragend', handleDragEnd);
      document.removeEventListener('mouseleave', handleDragEnd);
    };
  });

  var openFilePicker = function openFilePicker() {
    var _a;

    return (_a = fileInput.current) === null || _a === void 0 ? void 0 : _a.click();
  };

  var removeLocalFile = function removeLocalFile() {
    if (!isDropArea) {
      fileInput.current.value = '';
    }

    setUploadedFile(null);
  };

  var uploadFileLocally = function uploadFileLocally(file) {
    if (!file) return;
    var acceptedExtensions = acceptedFiles.split(', ').map(function (extension) {
      return extension.substring(1);
    }).join('|');
    var extensionValidationPattern = new RegExp("\\.((?!".concat(acceptedExtensions, ")[a-z]+)$"), 'i');
    var uploadErrorCode = validateAttachment(file, {
      extensionValidationPattern: extensionValidationPattern
    });

    if (uploadErrorCode) {
      setUploadError(errorMessages[uploadErrorCode]);
      removeLocalFile();

      if (!files[activeFileIndex + 1]) {
        setActiveFileIndex(0);
      }
    } else {
      setUploadedFile(file);
    }
  };

  var passFileToUpload = function passFileToUpload(e) {
    uploadFileLocally(e.target.files[0]);
    onFileSelect && onFileSelect(UploadAction.Browse, uploadType);
  };

  var uploadFile = function uploadFile() {
    if (uploadedFile) {
      onFileUpload(uploadedFile);
      removeLocalFile();
    }

    uploadNextFile();
  };

  var clearErrors = function clearErrors() {
    setUploadError(null);
    uploadNextFile(true);
  };

  var uploadNextFile = function uploadNextFile() {
    var isLastFileSkipped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextFileIndex = activeFileIndex + 1;
    var nextFileCount = fileCount + (isLastFileSkipped ? 1 : 2); // +2 because we already uploaded one file before calling uploadNextFile(), or +1 if previous file was not uploaded

    var isExceedingFileCountLimit = nextFileCount > fileLimit;
    var isNextFileExisting = files[nextFileIndex];

    if (isNextFileExisting && isExceedingFileCountLimit) {
      setUploadError(errorMessages[ValidationErrors.TotalQuantityError]);
      setFiles([]);
      setActiveFileIndex(0);
      setUploadedFile(null);
      return;
    }

    if (isNextFileExisting && !isExceedingFileCountLimit) {
      setActiveFileIndex(nextFileIndex);
      uploadFileLocally(files[nextFileIndex]);
      return;
    }

    setFiles([]);
    setActiveFileIndex(0);
    setUploadedFile(null);
  };

  var handleDragEnter = function handleDragEnter() {
    if (!isFrameDragActive && !disabled) {
      setIsFrameDragActive(true);
    }
  };

  var handleDragEnd = function handleDragEnd() {
    if (isFrameDragActive) {
      setIsFrameDragActive(false);
    }
  };

  var uploadMultipleFiles = function uploadMultipleFiles(files) {
    setFiles(files);
    uploadFileLocally(files[0]);
  };

  var handleFileDrop = function handleFileDrop(droppedFiles) {
    if (droppedFiles.length > 10) {
      setUploadError(errorMessages[ValidationErrors.QuantityError]);
      return;
    }

    setIsFrameDragActive(false);
    onFileSelect && onFileSelect(UploadAction.Browse, uploadType);
    checkHipaa(uploadMultipleFiles)(droppedFiles);
  };

  var handleConfirmModalCancel = function handleConfirmModalCancel() {
    removeLocalFile();
    uploadNextFile(true);
  };

  return React.createElement(React.Fragment, null, isDropArea ? React.createElement(HoverDropArea, {
    isFrameDragActive: isFrameDragActive,
    onFileDrop: handleFileDrop,
    disabled: disabled,
    isInsideModal: isInsideModal
  }) : React.createElement(React.Fragment, null, children(Object.assign({
    onClick: checkHipaa(openFilePicker)
  }, btnProps)), React.createElement(VisuallyHiddenElement, {
    as: "input",
    accept: acceptedFiles,
    id: "attachment",
    type: "file",
    onChange: passFileToUpload,
    ref: fileInput,
    tabIndex: -1,
    "aria-hidden": "true"
  })), React.createElement(UploadConfirmModal, {
    file: uploadedFile,
    onAccept: uploadFile,
    acceptLabel: confirmLabel,
    onCancel: handleConfirmModalCancel,
    fileUploadToTitle: fileUploadToTitle
  }), React.createElement(Modal, {
    narrow: true,
    title: uploadError ? uploadError.title : '',
    actions: React.createElement(Button, {
      secondary: true,
      onClick: clearErrors
    }, TEXT.ERROR_DISMISS_BTN),
    open: !!uploadError,
    onRequestClose: clearErrors
  }, !!uploadError && uploadError.description));
});